<template>
  <v-app>
    <!-- 
            v-row
                align : 設定垂直位置
                justify : 設定水平位置
         -->
    <v-row align="center" justify="center">
      <!-- 
                v-col
                    cols : 設定元件默認列數，值為1 ~ 12
                    sm: sm 斷點觸發時佔有的列數，值為1~12
                    md: md 斷點觸發時佔有的列數，值為1~12
             -->
      <v-col cols="12" sm="8" md="4">
        <!-- This is Login page -->
        <v-card
          class="elevation-8 pt-12 pb-12 pl-6 pr-6"
          color="rgba(255, 255, 255, 0.9)"
        >
          <v-card-title class="font-weight-black justify-center">
            <h1>{{ card.cardTitle }}</h1>
          </v-card-title>
          <form>
            <v-text-field
              v-model="account"
              :error-messages="accountErrors"
              label="帳號"
              required
              @click="clean"
            ></v-text-field>
            <v-text-field
              v-model="password"
              :error-messages="passwordErrors"
              label="密碼"
              type="password"
              required
              @click="clean"
            ></v-text-field>
            <v-row justify="center">
              <v-btn @click="login" color="primary" large> 登入 </v-btn>
            </v-row>
          </form>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>
<script>
import { setToken } from "@/utils/auth";
import { adminApi } from "@/api/admin";
export default {
  name: "Login",
  data: () => ({
    card: {
      cardTitle: "即刻上岸",
    },
    accountErrors: "",
    passwordErrors: "",
    account: "",
    password: "",
  }),
  methods: {
    async login() {
      await adminApi
        .login(this.account, this.password)
        .then((response) => {
          let role = response.data.role;
          let token = response.data.token;
          if (role !== "Admin") {
            alert("您没有权限访问该页面。请使用管理员账号登录。");
            return; // 终止后续代码执行
          }
          if (token != undefined) {
            setToken(token);
            this.$router.push({ path: "/user-management/account" });
          }
        })
        .catch((error) => {
          console.log("登入失敗");
          console.log("error = ", error);
          alert(`错误代码: ${error.code}\n错误信息: ${error.message}`);
          this.accountErrors = "帳號密碼錯誤";
          this.passwordErrors = this.accountErrors;
        });
    },
    clean() {
      this.accountErrors = "";
      this.passwordErrors = "";
    },
  },
};
</script>
<style scoped>
body {
  margin: 0;
}
#app {
  background: url("../assets/qingyou_login_background_2.jpg") no-repeat center
    center;
  background-size: cover;
}
</style>
